import React from "react";

const TableShowLimit = ({
  paginationCurrentLimit,
  setPaginationCurrentLimit,
}) => {
  return (
    <div className="flex sm:flex-row items-center gap-2 sm:gap-2 ml-2">
      <label
        htmlFor="pagination"
        className="text-sm font-Proxima text-textSecondary"
      >
        Rows per page:
      </label>
      <div className="text-xs">
        <select
          name="pagination"
          id="pagination"
          defaultValue={paginationCurrentLimit}
          onChange={(e) => {
            setPaginationCurrentLimit(e.target.value);
          }}
          className="px-2 py-1 font-Proxima"
        >
          <option value="10">10</option>
          <option value="15">15</option>
          <option value="20">20</option>
          <option value="25">25</option>
        </select>
      </div>
    </div>
  );
};

export default TableShowLimit;
